import { useApolloClient } from '@apollo/client';
import * as React from 'react';

import { getGoogleStartUrl, getLogoutUrl } from '../../lib/mopsAuthUrls';

/**
 * Hook that performs a mops-api logout: POSTs to `/auth/logout` to revoke the
 * session server-side, clears the Apollo cache, then navigates to the Google
 * OAuth start URL so the operator can re-authenticate from a clean slate.
 */
export const useLogout = () => {
  const apolloClient = useApolloClient();
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);

  const logout = React.useCallback(async () => {
    if (isLoggingOut) {
      return;
    }
    setIsLoggingOut(true);
    try {
      await fetch(getLogoutUrl(), {
        method: 'POST',
        credentials: 'include',
      });
    } catch {
      // Network failure still clears client state and bounces to the OAuth start.
    }
    await apolloClient.clearStore();
    window.location.assign(getGoogleStartUrl());
  }, [apolloClient, isLoggingOut]);

  return { logout, isLoggingOut };
};
